import React from "react";
import { CallToActionProps } from "../../../interfaces/interfaces.d";
import {
  CallToActionCardWrapper,
  IconBox,
  CardTitle,
  CardText,
  NavLink,
} from "./CallToActionCard.styles";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

export const CallToActionCard = ({
  image,
  icon,
  title,
  text,
  linkUrl,
  linkText,
}: CallToActionProps) => {
  return (
    <>
      <CallToActionCardWrapper>
          <IconBox>{icon}</IconBox>
          <CardTitle>{title}</CardTitle>
          <CardText>{text}</CardText>
          <NavLink to={`/${linkUrl}`}>
            <span>{linkText}</span>
            <span>
              <ArrowForwardIosIcon sx={{ fontSize: "80%", marginTop: "60%" }} />
            </span>
          </NavLink>
      </CallToActionCardWrapper>
    </>
  );
};
